import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function CookieBanner() {
	const [visible, setVisible] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		const choice = localStorage.getItem("cookiesChoice");
		if (!choice) setVisible(true);
		else if (choice === "accepted") {
			loadAnalyticsAndHotjar();
		}
	}, []);

	const loadAnalyticsAndHotjar = () => {
		const gaScript = document.createElement("script");
		gaScript.src = "https://www.googletagmanager.com/gtag/js?id=G-PSPQN4YS4F";
		gaScript.async = true;
		document.body.appendChild(gaScript);

		window.dataLayer = window.dataLayer || [];
		function gtag() {
			window.dataLayer.push(arguments);
		}
		window.gtag = gtag;

		gtag("consent", "default", {
			ad_storage: "denied",
			analytics_storage: "granted",
			wait_for_update: 500,
		});

		gtag("js", new Date());
		gtag("config", "G-PSPQN4YS4F", {
			anonymize_ip: true,
			allow_google_signals: false,
			allow_ad_personalization_signals: false,
		});

		if (localStorage.getItem("cookiesChoice") === "accepted") {
			(function (h, o, t, j, a, r) {
				h.hj =
					h.hj ||
					function () {
						(h.hj.q = h.hj.q || []).push(arguments);
					};
				h._hjSettings = { hjid: 5166596, hjsv: 6 };
				a = o.getElementsByTagName("head")[0];
				r = o.createElement("script");
				r.async = 1;
				r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
				a.appendChild(r);
			})(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
		}
	};

	const acceptCookies = () => {
		localStorage.setItem("cookiesChoice", "accepted");

		// Update GA consent to granted
		if (window.gtag) {
			window.gtag("consent", "update", {
				ad_storage: "granted",
				analytics_storage: "granted",
			});
		}

		loadAnalyticsAndHotjar();
		setVisible(false);
	};

	const rejectCookies = () => {
		localStorage.setItem("cookiesChoice", "rejected");

		if (window.gtag) {
			window.gtag("consent", "update", {
				ad_storage: "denied",
				analytics_storage: "denied",
			});
		}

		setVisible(false);
	};

	if (!visible) return null;

	return (
		<div className="fixed bottom-0 left-0 w-full bg-gray-900 text-white p-4 z-50">
			<div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm">
				<p>
					{t("cookies.text")}{" "}
					<a
						href="/politica-privacidad"
						target="_blank"
						rel="noopener noreferrer"
						className="underline text-primary hover:text-primary/80"
					>
						{t("cookies.link")}
					</a>
					.
				</p>

				<div className="flex flex-col items-center sm:items-end gap-1">
					<button
						onClick={acceptCookies}
						className="min-w-[160px] px-5 py-2 rounded bg-green-500 hover:bg-green-600 text-sm font-semibold shadow-md"
					>
						{t("cookies.accept")}
					</button>
					<button
						onClick={rejectCookies}
						className="text-xs underline text-gray-300 hover:text-gray-200"
					>
						{t("cookies.reject")}
					</button>
				</div>
			</div>
		</div>
	);
}
